import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, vShow as _vShow, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "mt-10 mb-10" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("批量下载")
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下载")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")

import { ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig} from '@/global_mixin/tableMixin'
import { formatNumber, formatTime, exportHandle } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  // 获取公司档案列表
  'POST/companies/archive': fetchList,
  // 上传公司文件
  'POST/companies/upload': uploadApi,
  // 下载公司文件
  'GET/upload/download': downloadApi,
  // 删除公司档案(>3天 逻辑删除，<=3天 物理删除)
  'DELETE/companies/archive/{id}': archiveDelApi,
  // 更新公司档案
  'PATCH/companies/archive': archiveUpApi,
  // 批量下载-公司档案
  'POST/companies/archive/batch_download': batch_downloadApi,
} = Api

let selectionRows = ref([])
const {
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  cpyCfig({
    upKey: 'companyIds',
    props: { clearable: true, multiple: true, 'collapse-tags': true, style: 'width: 350px' },
  }),
  {
    type: 'SELECT',
    // 是否显示有效文件
    label: '展示文件类型',
    value: false,
    upKey: 'valid',
    options: [
      { label: '全部有效文件', id: '' },
      { label: '非全部有效文件', id: false },
    ],
    props: { placeholder: '请选择是否显示有效文件', clearable: true },
    seleProps: { label: 'label', valueName: 'id' }
  },
  {
    type: 'SELECT',
    label: '档案类型',
    value: '',
    upKey: 'archiveType',
    options: [
      { label: '公司证照', id: 'UnitLicense' },
      { label: '租赁合同', id: 'LeaseContract' },
      { label: '审计报告', id: 'AuditReport' },
      { label: '会议记录', id: 'MeetingMinute' },
      { label: '工商文件', id: 'BusinessDocument' },
      { label: '其他', id: 'Other' },
    ],
    props: { placeholder: '请选择档案类型', clearable: true },
    seleProps: { label: 'label', valueName: 'id' }
  },
])
const upConfig = ref([
  cpyCfig(),
  {
    type: "TIME",
    label: "生效时间",
    value: '',
    upKey: 'effectiveDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: false,
    }
  },
  {
    type: "TIME",
    label: "预计失效时间",
    value: '',
    upKey: 'expectExpireDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: false,
    }
  },
  {
    type: "TIME",
    label: "实际失效时间",
    value: '',
    upKey: 'realExpireDate',
    props: {
      'value-format': 'YYYY-MM-DD',
      clearable: false,
    }
  },
  {
    label: "备注",
    value: '',
    upKey: 'note',
    props: { type: 'textarea', rows: 1 }
  },
  {
    type: 'SELECT',
    label: '档案类型',
    value: '',
    upKey: 'archiveType',
    options: [
      { label: '公司证照', id: 'UnitLicense' },
      { label: '租赁合同', id: 'LeaseContract' },
      { label: '审计报告', id: 'AuditReport' },
      { label: '会议记录', id: 'MeetingMinute' },
      { label: '工商文件', id: 'BusinessDocument' },
      { label: '其他', id: 'Other' },
    ],
    props: { placeholder: '请选择档案类型', clearable: true },
    seleProps: { label: 'label', valueName: 'id' }
  },
])

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 删除
const delHandle = (row: any) => {
  ElMessageBox.confirm(
    '创建时间小于等于3天内可以删除，3天后只能逻辑删除，即只记录删除人、删除时间，文件依旧存在',
    `是否确认删除: ${row.filename}?`,
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }
  )
    .then(() => {
      MI_identify.value = true
      return archiveDelApi({id: row.id})
    })
    .then(() => {
      MI_identify.value = false
      ElMessage.success('删除成功')
      fetchData(MI_params)
    })
    .catch(() => {
      MI_identify.value = false
      
    })
}

const formatArchiveType = (row: {archiveType: string}) => {
  switch (row.archiveType) {
    case 'UnitLicense':
      return '公司证照'
    case 'LeaseContract':
      return '租赁合同'
    case 'AuditReport':
      return '审计报告'
    case 'MeetingMinute':
      return '会议记录'
    case 'BusinessDocument':
      return '工商文件'
    case 'Other':
      return '其他'
  
    default:
      return 'unknow'
      break;
  }
}

// 批量下载
const batchDownload = () => {
  if(selectionRows.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  exportHandle(batch_downloadApi, {
    fileIds: selectionRows.value.map((row: {fileId: string}) => row.fileId)
  }).then(() => {
    ElMessage.success('下载成功')
    fetchData(MI_params)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TheUpBtn = _resolveComponent("TheUpBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_permission = _resolveDirective("permission")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "公司档案-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, { onSearchFn: _unref(fetchData) }), null, 16, ["onSearchFn"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (batchDownload()))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createVNode(_component_TheUpBtn, {
        upText: '上传公司文件',
        upFetch: _unref(uploadApi),
        upConfig: upConfig.value,
        upParams: {},
        onUpSuccess: _cache[1] || (_cache[1] = ($event: any) => (_unref(fetchData)(_unref(MI_params)))),
        showBtn: true
      }, null, 8, ["upFetch", "upConfig"])
    ]),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[2] || (_cache[2] = (rows) => _isRef(selectionRows) //@ts-ignore
 ? selectionRows.value = rows : selectionRows = rows),
      "max-height": _unref(MI_height)
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          widht: "55",
          type: "selection"
        }),
        _createVNode(_component_el_table_column, {
          label: "公司",
          prop: "companyName",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "档案类型",
          prop: "archiveType",
          width: "200",
          "show-overflow-tooltip": "",
          formatter: formatArchiveType
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          prop: "note",
          width: "200",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "上传日期",
          prop: "uploadAt",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "生效时间",
          prop: "effectiveDate",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "预计失效时间",
          prop: "expectExpireDate",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "实际失效时间",
          prop: "realExpireDate",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "删除时间",
          prop: "deletedAt",
          "show-overflow-tooltip": "",
          formatter: _unref(formatTime)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "删除人",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            (!row.deletedAt)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(`${row.deletedName}(${row.deletedAlias})`), 1))
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "上传人",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "文件名",
          prop: "filename",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_space, null, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_eptBtn, {
                  type: "primary",
                  exportFn: _unref(downloadApi),
                  exportParam: {fileId: row.fileId, filename: row.filename}
                }, {
                  default: _withCtx(({exportFn, downFg}) => [
                    _createVNode(_component_el_link, {
                      type: "primary",
                      onClick: exportFn
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["exportFn", "exportParam"])), [
                  [_directive_permission, void 0, "checkin"]
                ]),
                _withDirectives(_createVNode(_component_el_link, {
                  type: "danger",
                  onClick: ($event: any) => (delHandle(row))
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 2
                }, 1032, ["onClick"]), [
                  [_vShow, row.archiveType !== 'LeaseContract']
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})